<template>
  <form class="form" @submit.prevent="saveChanges">

    <div class="kt-form kt-form--label-right">

      <div class="form-group row">
        <label class="col-xl-4 col-lg-3 col-form-label"></label>
        <div class="col-xl-4 col-lg-6">
          <h5>Personal information:</h5>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-xl-4 col-lg-3 col-form-label">Email</label>
        <div class="col-xl-4 col-lg-6">
          <input
            type="text"
            class="form-control"
            disabled
            v-model="personalInfo.email">
        </div>
      </div>

      <div class="form-group row">
        <label class="col-xl-4 col-lg-3 col-form-label">First name <BaseRequiredField /></label>
        <div class="col-xl-4 col-lg-6">
          <input
            type="text"
            class="form-control"
            :class="{ 'is-invalid': $v.firstName.$error }"
            v-model.trim="firstName"
            @blur="$v.firstName.$touch()">
          <template v-if="$v.firstName.$error">
            <div class="invalid-feedback" v-if="!$v.firstName.required"><font-awesome-icon :icon="['fas', 'exclamation-triangle']" class="mr-1" /> First name is required</div>
          </template>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-xl-4 col-lg-3 col-form-label">Last name <BaseRequiredField /></label>
        <div class="col-xl-4 col-lg-6">
          <input
            type="text"
            class="form-control"
            :class="{ 'is-invalid': $v.lastName.$error }"
            v-model.trim="lastName"
            @blur="$v.lastName.$touch()">
          <template v-if="$v.lastName.$error">
            <div class="invalid-feedback" v-if="!$v.lastName.required"><font-awesome-icon :icon="['fas', 'exclamation-triangle']" class="mr-1" /> Last name is required</div>
          </template>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-xl-4 col-lg-3 col-form-label">About you: <BaseRequiredField /></label>
        <div class="col-xl-4 col-lg-6">
          <textarea
            rows="5"
            class="form-control"
            :class="{ 'is-invalid': $v.aboutYou.$error }"
            v-model.trim="aboutYou"
            @blur="$v.aboutYou.$touch()" />
          <template v-if="$v.aboutYou.$error">
            <div class="invalid-feedback" v-if="!$v.aboutYou.required"><font-awesome-icon :icon="['fas', 'exclamation-triangle']" class="mr-1" /> About you is required</div>
          </template>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-xl-4 col-lg-3 col-form-label">Avatar</label>
        <div class="col-xl-4 col-lg-6 ">
          <div class="kt-avatar kt-avatar--outline kt-avatar--circles">
            <div class="kt-avatar__holder" :style="`background-image: url(img/user-avatar.png);`"></div>
            <label class="kt-avatar__upload" data-toggle="kt-tooltip" title="" data-original-title="Change avatar" v-if="false">
                <font-awesome-icon :icon="['fas', 'pen']" />
                <input type="file" name="profile_avatar" accept=".png, .jpg, .jpeg" disabled>
            </label>
            <span class="kt-avatar__cancel" data-toggle="kt-tooltip" title="" data-original-title="Cancel avatar" v-if="false">
                <font-awesome-icon :icon="['fas', 'times']" />
            </span>
          </div>
        </div>
      </div>

      <div class="kt-separator kt-separator--border-dashed"></div>

      <div class="form-group row">
        <label class="col-xl-4 col-lg-3 col-form-label"></label>
        <div class="col-xl-4 col-lg-6">
          <h5>Region and brand</h5>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-xl-4 col-lg-3 col-form-label">Region(s)</label>
        <div class="col-xl-4 col-lg-6 d-flex align-items-center">
          <span class="kt-badge kt-badge--brand  kt-badge--inline kt-badge--pill"
                v-for="(r, index) in personalInfo.region" :key="index">{{ r.text }}</span>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-xl-4 col-lg-3 col-form-label">Brand(s)</label>
        <div class="col-xl-4 col-lg-6 d-flex flex-wrap align-items-center">
          <span
            class="kt-badge kt-badge--brand  kt-badge--inline kt-badge--pill mr-2 mb-1 text-capitalize"
            v-for="(b, index) in personalInfo.brand"
            :key="index">{{ b.text }}</span>
        </div>
      </div>

    </div>

    <div class="text-center">
      <div class="kt-separator kt-separator--border-dashed"></div>
      <BaseButton type="submit" classButton="btn btn-danger btn-bold btn-wide" :disabled="$v.$invalid || isLoading">
        <span>Save changes</span>
        <font-awesome-icon :icon="['fas', 'spinner']" spin class="ml-1" v-if="isLoading" />
      </BaseButton>
    </div>

  </form>
</template>

<script>
import NProgress from 'nprogress'
import { mapGetters } from 'vuex'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'PersonalInformation',
  data () {
    return {
      isLoading: false,
      firstName: '',
      lastName: '',
      aboutYou: ''
    }
  },
  computed: {
    ...mapGetters({
      'personalInfo': 'profile/personalInformation'
    })
  },
  validations: {
    firstName: { required },
    lastName: { required },
    aboutYou: { required }
  },
  beforeMount () {
    this.firstName = this.personalInfo.firstName
    this.lastName = this.personalInfo.lastName
    this.aboutYou = this.personalInfo.aboutYou
  },
  methods: {
    saveChanges () {
      this.$v.$touch()
      if (!this.$v.$invalidad) {
        const form = {
          firstName: this.firstName,
          lastName: this.lastName,
          aboutYou: this.aboutYou
        }
        NProgress.start()
        this.isLoading = true
        this.$store
          .dispatch('profile/savePersonalInformation', form)
          .then((response) => {
            this.isLoading = false
            NProgress.done()
            this.$notification.success('Changes saved successfully!')
            return response
          })
          .then((response) => {
            if (response.status) {
              this.$store.dispatch('auth/refreshToken')
                .then((response) => {})
                .catch(error => {
                  if (error.response && error.response.status > 400) { // 401 || 403
                    // store.dispatch('auth/removeToken')
                  }
                })
            }
          })
          .catch((error) => {
            this.isLoading = false
            NProgress.done()
            this.$notification.error(error.response.data.message)
          })
      }
    }
  }
}
</script>
